import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button } from '@pd/pd-ui-kit';


import { options } from "./options";
import { usePermissions } from "~/shared/context/PermissionContext";
import Wrapper from '~/shared/ui/Wrapper';

import cls from "./EditorDirectories.less";

const EditorDirectories = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const goBack = () => history.replace("/editor/");
  const { hasPermission, loading: loadingPermissions } = usePermissions();

  return (
    <Wrapper.Content
      title={t("directories.directories")}
      txtBtn={t("ui.back")}
      goBackHandler={goBack}
    >
      <div className={cls.wrapper_items}>
        {options.map((item) => {
          if (loadingPermissions || !hasPermission(item.permissions)) {
            return null;
          }

          return (
            <div className={cls.item} key={item.id}>
              <div className={cls.item__content}>
                <div className={cls.item__title}>
                  {t(`editor.${item.description_lang_key}`)}
                </div>
              </div>
              <div className={cls.button}>
                <Button
                  onClick={() => history.push(item.path)}
                >
                  {t("ui.go_over")}
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </Wrapper.Content>
  );
};

export default EditorDirectories;
